<template>
  <v-container class="pt-0">
    <v-row
      ><v-col class="mx-0 px-0 pt-0">
        <header-text-bg
          :site="site"
          text="menuCampaign"
          :redirect_name="redirect_name"
          :hide_back="inBottomNavbar"
        />
      </v-col>
    </v-row>

    <v-row justify="space-around" style="margin-top: -30px" class="mx-2">
      <v-btn
        elevation="5"
        class="rounded-lg"
        @click="onClickType('all')"
        :style="{
          backgroundColor: type == 'all' ? site.color : 'white',
          minWidth: '160px',
        }"
      >
        <p
          class="text-justify mb-0 text-capitalize"
          :style="{
            color: type == 'all' ? 'white' : 'black',
          }"
        >
          <v-icon
            left
            :style="{
              color: type == 'all' ? 'white' : site.color,
            }"
            style="margin-right: 0px"
            >mdi-view-grid-outline</v-icon
          >
          {{ $t("all") }}
        </p>
      </v-btn>
      <v-btn
        elevation="5"
        class="rounded-lg"
        @click="onClickType('joined')"
        :style="{
          backgroundColor: type == 'joined' ? site.color : '',
          minWidth: '160px',
        }"
      >
        <p
          class="text-justify mb-0 text-capitalize"
          :style="{
            color: type == 'joined' ? 'white' : 'black',
          }"
        >
          <v-icon
            left
            :style="{
              color: type == 'joined' ? 'white' : site.color,
            }"
            style="margin-right: 0px"
            >mdi-account-box-outline</v-icon
          >
          {{ $t("joined") }}
        </p>
      </v-btn>
    </v-row>

    <v-row class="px-2 mt-6 mb-2">
      <v-col
        v-for="(item, index) in listData"
        :key="index"
        cols="12"
        class="py-1"
      >
        <v-sheet rounded>
          <v-card
            elevation="2"
            rounded="lg"
            @click="onClickCard(item)"
            :disabled="item.is_expired"
            :style="{
              backgroundColor: item.is_expired ? '#E0E0E0' : '#ffffff',
            }"
          >
            <v-card-title class="py-1 px-1">
              <v-container>
                <v-row>
                  <v-col cols="12" class="pa-1">
                    <div class="d-flex" style="gap: 14px; z-index: 1">
                      <div
                        style="
                          width: 150px;
                          min-width: 164px;
                          height: 100px;
                          border-radius: 8px;
                          overflow: hidden;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          position: relative;
                        "
                      >
                        <v-img
                          style="width: 100%; height: 100%"
                          :cover="true"
                          :aspect-ratio="1"
                          :lazy-src="require('@/assets/images/image.png')"
                          :src="item.image_url"
                        >
                        </v-img>
                        <v-icon
                          v-if="item.joined"
                          style="
                            position: absolute;
                            bottom: 0;
                            right: 0px;
                            background-color: #ffffff;
                            border-radius: 4px 0px 0px 0px;
                          "
                          :color="site.color"
                          >mdi-account-box-outline</v-icon
                        >
                      </div>

                      <div
                        class="d-flex flex-column"
                        style="width: calc(100% - 178px)"
                      >
                        <p
                          class="description-label title-card text-start mb-0 pb-0 text-subtitle-2"
                        >
                          {{ item.name }}
                        </p>
                        <p
                          class="title-card text-start mb-0 pb-0 grey--text text--darken-1 pt-1"
                          style="font-size: 12px; word-break: normal"
                        >
                          <!-- {{ $t("date") }} : -->
                          {{ item.start_date | formatDate }} -
                          {{ item.end_date | formatDate }}
                        </p>
                        <div
                          v-if="item.joined && type == 'joined'"
                          class="mb-0 mt-auto"
                        >
                          <p
                            v-if="item.show_total_point"
                            class="title-card text-start pb-0 mb-0"
                            style="font-size: 12px; word-break: normal"
                          >
                            {{ $t("campaignTotalPoint") }} :
                            {{
                              item.total_point
                                ? item.total_point.toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })
                                : "-"
                            }}
                          </p>
                          <p
                            v-if="item.show_total_summary_amount"
                            class="title-card text-start pb-0 mb-0"
                            style="font-size: 12px; word-break: normal"
                          >
                            {{ $t("campaignTotalAmount") }} :
                            {{
                              item.total_summary_amount
                                ? item.total_summary_amount.toLocaleString(
                                    "en-US",
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }
                                  )
                                : "-"
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-title>
          </v-card>
        </v-sheet>
      </v-col>
    </v-row>

    <div>
      <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
        <div slot="spinner"></div>
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>

    <div v-if="!listData.length">
      <v-col class="d-flex justify-center mt-16">
        <v-img
          class="white--text mx-auto mt-10 empty"
          :src="require('@/assets/images/out-of-stock.png')"
          max-width="150px"
        >
        </v-img>
      </v-col>
      <p class="text-center">{{ $t("errDataNotFound") }}</p>
    </div>

    <div
      class="fab-container"
      :style="{
        'padding-bottom': showBottomNavbar ? '70px' : '0px',
      }"
    >
      <v-btn
        v-if="checkFloatPanel"
        fab
        dark
        :color="site.color"
        class="mr-6"
        @click="dialogFloatPanel = true"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </div>

    <FloatPanel
      :dialog="dialogFloatPanel"
      @onClose="dialogFloatPanel = false"
    />
  </v-container>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import { mapState } from "vuex";
import Axios from "@/config/customer-service";
import moment from "moment";
import HeaderTextBg from "@/components/headerTextBg.vue";
import FloatPanel from "../../../components/floatPanel.vue";

export default {
  name: "HistoryCode",
  inject: ["isAppLoading"],
  components: {
    HeaderTextBg,
    InfiniteLoading,
    FloatPanel,
  },

  data() {
    return {
      next_page_url: "",
      infiniteId: +new Date(),
      listData: [],
      type: "all",
      dialogFloatPanel: false,
      redirect_name: "main",
    };
  },
  created() {},
  methods: {
    infiniteHandler($state) {
      this.isAppLoading(true);
      Axios.get(`microsite/getListMicrositeSyncMcommerce`, {
        params: {
          type: this.type,
          page: this.next_page_url,
        },
      })
        .then(({ data }) => {
          if (Array.isArray(data?.data?.data)) {
            let has_more = data.data.has_more;
            this.listData = this.listData.concat(data.data.data);
            if (!has_more) {
              $state.complete();
              return;
            }
            this.next_page_url = data.data.next_page_url.split("=")[1];
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },

    onClickCard(param) {
      const slug = param.slug;
      this.$router.push({
        name: `microsite-login`,
        params: { slug: slug },
      });
    },
    onClickType(param) {
      this.type = param;
      this.listData = [];
      this.next_page_url = "";
      this.infiniteId += 1;
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
    inBottomNavbar() {
      let check = false;
      // ========== ========== ========== ==========
      const curRouteName = this.$router.currentRoute.name;
      let listRouteName = [];
      if (
        Array.isArray(this.site?.bottom_nav_bar?.menu) &&
        this.site?.bottom_nav_bar?.menu?.length > 0
      ) {
        const listRouteAllow = this.site?.bottom_nav_bar.menu.map(
          (x) => x.route_allow
        );
        for (let item of listRouteAllow) {
          listRouteName = [...listRouteName, ...item];
        }
      }
      if (listRouteName.length > 0 && listRouteName.includes(curRouteName)) {
        check = true;
      }
      return check;
    },
    showBottomNavbar() {
      let check = false;
      // ========== ========== ========== ==========
      let checkInRoute = true;
      const curRouteName = this.$route.name;
      let listRouteName = [];
      if (
        Array.isArray(this.site?.bottom_nav_bar?.menu) &&
        this.site?.bottom_nav_bar?.menu?.length > 0
      ) {
        const listRouteAllow = this.site?.bottom_nav_bar.menu.map(
          (x) => x.route_allow
        );
        for (let item of listRouteAllow) {
          listRouteName = [...listRouteName, ...item];
        }
      }
      if (listRouteName.length > 0 && !listRouteName.includes(curRouteName)) {
        checkInRoute = false;
      }
      // ========== ========== ========== ==========
      if (this.site.is_use_bottom_nav && checkInRoute) {
        check = true;
      }
      return check;
    },
    checkFloatPanel() {
      let check = false;
      if (this.site.is_use_float_panel) {
        const float_panel_main_menu = this.site.float_panel_main?.menu || [];
        const float_panel_extend_menu =
          this.site.float_panel_extend?.menu || [];
        const model_main_all_open = float_panel_main_menu.find((x) => x.show);
        const model_extend_all_open = float_panel_extend_menu.find(
          (x) => x.show
        );
        if (model_main_all_open || model_extend_all_open) {
          check = true;
        }
      }
      return check;
    },
  },
  watch: {},
  filters: {
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("DD MMM YY, HH:mm");
    },
  },
};
</script>

<style scoped>
.description-label {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.title-card {
  line-height: 1.3;
}

.fab-container {
  position: fixed;
  bottom: 16px;
  right: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  z-index: 1;
}
</style>
